<template>
  <div class="image-preview" :title="label">
    <div v-if="src" class="image-container">
      <img :src="src" :alt="label" class="preview-image" />
    </div>
    <div v-else class="empty-image">
      <v-icon color="grey">image</v-icon>
    </div>
    <span class="image-label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'ImagePreview',
  props: {
    src: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.image-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 8px;
  min-width: 40px;

  .image-container,
  .empty-image {
    width: 32px;
    height: 32px;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f5f5f5;
  }

  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .empty-image {
    background-color: #fafafa;
  }

  .image-label {
    font-size: 10px;
    color: #666;
    margin-top: 2px;
    text-align: center;
    line-height: 1.2;
  }
}
</style>
